import React from 'react';
import { X } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export const PolicyModal = ({
  isOpen,
  onClose,
  title,
  content
}: PolicyModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 backdrop-blur-sm" data-id="element-279">
      <div className="bg-white rounded-xl w-full max-w-3xl p-8 relative shadow-2xl max-h-[80vh] overflow-y-auto" data-id="element-280">
        <button onClick={onClose} className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 transition-colors duration-200" aria-label="Close modal" data-id="element-281">
          <X className="h-6 w-6" data-id="element-282" />
        </button>
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-283">{title}</h2>
        <div className="prose max-w-none" data-id="element-284">{content}</div>
      </div>
    </div>;
};